import { capitalize } from "@/lib/utils";
import { DrupalNode } from "next-drupal";

export interface BreadCrumb {
    link: string,
    title: string,
}

// This is a helper function to fetch global elements for layout.
// This is going to be run for every pages on build.
// To make this fast, you could cache the results example on Redis.
export function getBreadCrumbs(content:DrupalNode): BreadCrumb[] {
    const arrayBreadCrumbs = [] as BreadCrumb[];
    const path = content.path.alias.split("/");
    path.pop();
    arrayBreadCrumbs.push({ "title": "Home", "link": "/" });
    let previousPath = "/es/";

    function processTitle(title) {
        return capitalize(title.replaceAll("-", " "));
    }

    if(content.type == "node--recipe"){
        previousPath = previousPath + "escuela-del-jamon/";
        arrayBreadCrumbs.push({ "title": "Recetas", "link": `${previousPath}recetas/` });
        if(content.field_category){
            arrayBreadCrumbs.push({ "title": content.field_category.name, "link": content.field_category.path.alias });
        }
        arrayBreadCrumbs.push({ "title": processTitle(content.title), "link": undefined });
    }else if(content.type == "node--article"){
        previousPath = previousPath + "escuela-del-jamon/";
        arrayBreadCrumbs.push({ "title": "Escuela del jamón", "link": previousPath });
        arrayBreadCrumbs.push({ "title": content.field_category.name, "link": content.field_category.path.alias });
        arrayBreadCrumbs.push({ "title": processTitle(content.title), "link": undefined });
    }else{        
        path.map((item) => {
            if(item != "" && item != "es"){
                arrayBreadCrumbs.push({ "title": processTitle(item),
                        "link": previousPath + item });
            }
            previousPath = previousPath + item + "/";
        });
        arrayBreadCrumbs.push({ "title": processTitle(content.title), "link": undefined });
    }

    return arrayBreadCrumbs;
}